import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage content-grid--subpage-table" }
const _hoisted_2 = { class: "content-grid__header" }
const _hoisted_3 = { class: "back-link-title" }
const _hoisted_4 = { class: "content-grid__filters" }

import Card from "@/components/layout/Card.vue";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import SearchInput from "@/components/layout/SearchInput.vue";
import { useI18n } from "vue3-i18n";
import {ref, onMounted, computed} from "vue";
import { useOrganizationService } from "@/inversify.config";
import DataTable from "@/components/layout/DataTable.vue";
import {IOrganization} from "@/types/entities/organization";
import BtnLink from "@/components/layout/BtnLink.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminOrganizationIndex',
  setup(__props) {

const { t } = useI18n();

const organizationService = useOrganizationService();

const allOrganizations = ref();
const searchValue = ref("");
const organizationsAreLoading = ref(false);

const organizationHeader = [
  {
    text: t("organization.name"),
    value: "name",
    sortable: true,
    width: 325,
  },
  {
    text: t("organization.status"),
    value: "status",
    sortable: true,
    width: 150,
  },
  {
    text: t("organization.type"),
    value: "type",
    sortable: true,
    width: 125,
  },
  {
    text: t("organization.memberNumber"),
    value: "memberNumber",
    sortable: true,
    width: 150,
  },
  {
      text: t("global.table.actions"),
      value: "actions",
      width: 75
  },
];

const organizations = computed(() => {
    if (allOrganizations.value == null) {
        return []
    }
    return allOrganizations.value.map((x: IOrganization) => {
        return {
            id: x.id,
            crmId: x.crmId,
            name: x.name,
            type: t(`organization.types.${x.type.makeFirstLetterLowercase()}`),
            memberNumber: x.memberNumber,
            status: t(`organization.statuses.${x.subscriptionStatus.makeFirstLetterLowercase()}`),
            actions: {
              view: {name: "admin.children.organizations.view", params: {organizationId: x.id}}
            }
        }
    }) as IOrganization[];
})

onMounted(async () => {
  await loadAllOrganizations();
});

async function loadAllOrganizations() {
  organizationsAreLoading.value = true;

  let organizations = await organizationService.getAllOrganizations();
  if (organizations && organizations.length > 0) {
    allOrganizations.value = organizations;
  }
  organizationsAreLoading.value = false;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, {
      title: _unref(t)(`routes.admin.children.organizations.name`)
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)(`routes.admin.children.organizations.name`)), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SearchInput, {
          modelValue: searchValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(Card, {
      title: _unref(t)('global.quickLinks'),
      class: "card--row-content"
    }, {
      default: _withCtx(() => [
        _createVNode(BtnLink, {
          name: _unref(t)('routes.admin.children.organizations.merge.name'),
          path: { name: 'admin.children.organizations.merge' }
        }, null, 8, ["name", "path"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(Card, null, {
      default: _withCtx(() => [
        _createVNode(DataTable, {
          headers: organizationHeader,
          items: organizations.value,
          "is-loading": organizationsAreLoading.value,
          "search-value": searchValue.value
        }, null, 8, ["items", "is-loading", "search-value"])
      ]),
      _: 1
    })
  ]))
}
}

})